import React from "react";

interface TopImageProps {
  imageSrc: string;
  alt: string;
}

const TopImage: React.FC<TopImageProps> = ({ imageSrc, alt }) => {
  return (
    <div className="TopImage">
      <img src={imageSrc} alt={alt} />
    </div>
  );
};

export default TopImage;
